<template>
  <div id="guotu">
    <!-- 头部 -->
    <!-- <img v-show="!$store.state.loading_state" src="../../assets/forest/index/logo.png" alt="" class="head_left" /> -->
    <!-- 区划 -->
    <quhua v-show="!$store.state.loading_state" id="quhua" ref="quhua"></quhua>
    <!-- 版本号 -->
    <div class="version" v-show="!$store.state.loading_state">
        <p>GS京(2023) 0227号 版本号：{{ version }}</p>
    </div>
    <!-- 放大缩小 -->
    <zoom id="zoom" v-show="!$store.state.loading_state"></zoom>
    <!-- 右侧功能框 -->
    <rightPop class="rightPop"></rightPop>
    <!-- PDF弹框 -->
    <pdfPop></pdfPop>
    <!-- 经营对比 -->
    <contrast></contrast>
    <!-- 全景影像 -->
    <panorama></panorama>
    <!-- 视频弹框 -->
    <videoPop></videoPop>
  </div>
</template>

<script>
let that;
const quhua = () => import("./quhua/quhua.vue");
const zoom = () => import("./index/zoom.vue");
const videoPop = () => import("./index/videoPop.vue");
const contrast = () => import("./qy/contrast.vue")
const panorama = () => import("./qy/panorama.vue")
const rightPop = () => import("./quhua/right_pop.vue");
const pdfPop = () => import("./quhua/pdfPop.vue");
export default {
  name: "forest",
  components: {
    quhua, zoom, contrast, panorama, videoPop, rightPop, pdfPop
  },
  data() {
    return {
      isOnScene: false, // 基础场景加载
      all_state: true,
      year_state: false,
      width: 0,
      version: "",
      width_center: 16,
      logo: {
        username: "admin",
      },
      // center: "全国",
    };
  },
  methods: {
    set_tu() {
      if (!this.add_2021_state) {
        if (!this.yingxiang) {
          this.yingxiang = window.Module.asm.Folder_AddFolder(that.$store.state.root);
        }
        // 添加2021年影像
        this.add_2021_state = true;
        let layer = window.Module.asm.Folder_AddImageLayer(this.yingxiang, allocate('http://t16.stgz.org.cn/datapublish_service/gettileMerge?scene=default&type=edom&ds=g46&tk=qc_user'))
        window.Module.asm.ImageLayer_SetOrder(layer, 0);
        window.Module.asm.SetLayer_Visible(layer, false);

        // 添加2022年影像
        let layer_22 = window.Module.asm.Folder_AddImageLayer(this.yingxiang, allocate('http://t16.stgz.org.cn/datapublish_service/gettileMerge?scene=default&type=edom&ds=g47&tk=qc_user'))
        window.Module.asm.ImageLayer_SetOrder(layer_22, 0);
        window.Module.asm.SetLayer_Visible(layer_22, false);
      }
      let obj = { year_2021: 0, year_2022: 1 }
      // 图层数据加载
      that.$store.state.tcList.forEach((v, i) => {
        if (i == 0) {
          v.children[0].shuju = window.Module.asm.Folder_Child(this.yingxiang, obj['year_' + that.$store.state.active_year]);
        }
      })
      window.Module.asm.SetLayer_Visible(that.$store.state.tcList[0].children[0].shuju, true);
    },
    // AES混淆转base64
    AESToBase64Encrypt(str) {
      var key = CryptoJS.enc.Utf8.parse("STGZSJCJYAPI_KEY");
      var iv = CryptoJS.enc.Utf8.parse("STGZSJCJYINIT_IV");
      var encrypted = CryptoJS.AES.encrypt(str, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return MyBase64.tranCode.encode(encrypted.toString());
    },
  },
  mounted() {
    that = this;
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      alert("不支持IE浏览器,请使用edge或chrome!");
      this.msg = "当前浏览器不支持，无法加载";
    } else {
      this.$store.state.sanwei.type_data = this.$route.query.type;
      this.$store.state.set_tu = this.set_tu;
    }
    window.onresize = function () {
      // that.$store.state.zoom = 100 / Number(that.$store.state.detectZoom());
      // document.body.style['-moz-transform'] = 'scale('+100/Number(that.$store.state.detectZoom())+')'
      // document.body.style['-moz-transform-origin'] = '0 0'
      that.top = (document.getElementById("app").clientHeight - 400) / 2;
    };
    // 主场景完成加载回调
    window.OnSceneOpened = function () {
      if (!that.$store.state.root) {
        // 进入顶视图
        window.Module.asm.ViewPoint_SetViewModel(1);
        // 全局挂载AES加密方法
        that.$store.state.AESToBase64Encrypt = that.AESToBase64Encrypt;
        that.$store.state.urlIp = window.location.origin + window.location.pathname;  //  全局使用当前部署网络地址(到项目名)
        that.$store.state.root = window.Module.asm.Scene_RootFolder();
        // 场景加载初始化配置
        that.$tranSmit.$emit("SceneOpenedConfig");
        // 初始化到中国
        if (that.$route.query.lat) {
          let obj = that.$route.query;
          window.Module.asm.CameraController_FlyTo(
            obj.lon,
            obj.lat,
            obj.alt,
            obj.tilt,
            obj.head,
            1
          );
        } else {
          // 中国
          window.Module.asm.CameraController_FlyTo(
            106.72974193752866,
            29.79668112220561,
            6410665.489473,
            0,
            0,
            0
          );
        }
        that.version = UTF8ToString(window.Module.asm.Version());
        // 设置底部文字大小
        // window.Module.asm.Display_SetCoordinateFontPixelSize(14);
        // 向下偏移20px隐藏坐标信息
        window.Module.asm.Display_SetCoordinateOffsetY(20)
        setTimeout(() => {
          that.$store.state.loading_state = false;
          that.$store.state.zt_state = true;
          window.OnCameraChanged = function () {
            let alt = parseInt(window.Module.asm.CameraController_GetAltitude());
            let lon = window.Module.asm.CameraController_GetLongitude();
            let lat = window.Module.asm.CameraController_GetLatitude();
            if (alt > 7000 * 1000) {
              window.Module.asm.CameraController_SetPosition(lon, lat, 7000 * 1000);
            } else if (alt < 15 * 1000) {
              window.Module.asm.CameraController_SetPosition(lon, lat, 15 * 1000);
            }
          }
        }, 3000);
        that.$store.state.diTu = window.Module.asm.Folder_AddFolder(
          that.$store.state.root
        );
      }
    };
    // 子场景完成加载回调
    window.OnFolderOpened = function (url) {
      // 设置图层控制
      if (!that.isOnScene) {
        let subNode = window.Module.asm.Folder_Child(that.$store.state.root, 1);
        let mainScene = window.Module.asm.Folder_Child(subNode, 0);
        window.Module.asm.Folder_RemoveLayer(subNode, mainScene);
        // that.$store.state.traverseSceneTree();
        // if (that.$store.state.showMode == 0) {
        // }
      } else {
        setTimeout(() => {
          that.$tranSmit.$emit("setLayer_Layer", true, 2, 0); // 加载图斑
        }, 2000);
      }
      that.isOnScene = false;
    };
    window.OnObjectMouseUp = (name, type, xml) => {
      let objName = UTF8ToString(name);
      let xmlObj = {};
      UTF8ToString(xml).split(',').forEach(v => {
        let arr = v.split(':');
        xmlObj[arr[0]] = arr[1]
      })
      if ((objName.substr(0, 2) === "QJ") && this.$store.state.qjUrl.length == 0) {
        let arr = objName.substr(2).split('|')
        this.$store.state.qjUrl = arr[1];
        this.$tranSmit.$emit("showPanorama", "QJ", arr[0], this.$store.state.qjUrl);
      } else if (xmlObj.markID.substr(0, 2) === "QJ") {
        let arr = xmlObj.markID.substr(2).split('|')
        this.$store.state.qjUrl = arr[1];
        this.$tranSmit.$emit("showPanorama", "QJ", arr[0], this.$store.state.qjUrl);
      }
      else if (objName.substr(0, 5) === "VIDEO") {
        let arr = objName.substr(5).split('|')
        this.$tranSmit.$emit("showVideo", arr[0], arr[1]);
      } else if (objName.substr(0, 5) === "GUIDE") {
        this.$tranSmit.$emit("guideSetActiveItem", objName.substr(5));
      } else if (objName === "IMG") {
        this.$tranSmit.$emit("openImgViewer");
      } else if (xmlObj.markID.substr(0, 2) === "LC") {
        this.$store.state.activeLcName = xmlObj.markID.substr(2);
        let geo;
        this.$store.state.arr_quhua[0].forEach(v => {
          v.children[0].children.forEach(i => {
            if (i.name == xmlObj.markID.substr(2) && i.shape) {
              let shap = JSON.parse(i.shape);
              geo = shap.features ? shap.features[0].geometry : shap;
            }
          })
        });
        if (geo) {
          this.$store.state.draw_geo(geo, 3);
        }
        let obj = this.$store.state.lcPointsData.find(v => v.name == xmlObj.markID.substr(2));
        window.Module.asm.CameraController_FlyTo(obj.lon, obj.lat, obj.alt, 0, 0, 1.5);
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin background {
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-radius: 5px;
}

.head_left {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 100;
}

#center {
  position: absolute;
  z-index: 10;
  color: #fff;
  font-size: 12px;
  bottom: 3px;
}

#right_top {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 100;

  .right_pie {
    display: inline-block;
    width: 35px;
    cursor: pointer;
    height: 35px;
    background-image: url("../../assets/forest/right/total.png");
    background-size: 100% 100%;

    &:hover,
    &.active {
      background-image: url("../../assets/forest/right/total_a.png");
    }
  }

  .right_btn {
    display: inline-block;
    width: 35px;
    height: 35px;
    color: rgba(255, 255, 255, 0);
    background-image: url("../../assets/forest/right/show.png");
    background-size: 100% 100%;
    cursor: pointer;

    &:hover,
    &.active {
      background-image: url("../../assets/forest/right/show_a.png");
    }
  }
}

.version {
  position: absolute;
  left: 20px;
  bottom: 6px;
  color: #fff;
  text-align: left;
  z-index:100;

  span {
    display: inline-block;
    width: 35px;
    height: 35px;
    cursor: pointer;
    background: url("../../assets/forest/index/zt_min.png");
    background-size: 100% 100%;
    margin-bottom: 4px;

    &:hover {
      background: url("../../assets/forest/index/zt_min_active.png");
      background-size: 100% 100%;
    }
  }

  p {
    padding-left: 80px;
    font-size: 12px;
  }
}

#pic,
#shenbao,
#total {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1100;
}

#xiaoban {
  position: fixed;
  left: 20px;
  top: 145px;
}

#quhua {
  position: absolute;
  left: 10px;
  top: 10px;
  display: flex;
  align-items: center;
  z-index:100;
}

#zhuanti {
  position: absolute;
  right: 18px;
  bottom: 20px;
}

#layer {
  position: absolute;
  right: 70px;
  bottom: 70px;
  z-index: 40;
}

#all {
  position: fixed;
  left: 20px;
}

#right_b {
  position: absolute;
  right: 18px;
  bottom: 60px;

  li,
  div {
    cursor: pointer;
    margin-bottom: 6px;
    display: inline-block;
    width: 45px;
    height: 45px;
    background-image: url("../../assets/forest/right/year_bg.png");
    background-size: 100% 100%;

    &.layer_btn {
      background-image: url("../../assets/forest/right/layer.png");

      &:hover {
        background-image: url("../../assets/forest/right/layer_a.png");
      }
    }
  }
}

.rightPop {
  position: absolute;
  right: 0px;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/forest/forest.vue